<div>
  <app-header *ngIf="showHeader"></app-header>
  <app-toast aria-live="polite" aria-atomic="true"></app-toast>
  <div class="az-content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="showFooter"></app-footer>
</div>
